// File naming convention for locale files:
// URL format: portal/<country>/<language>
// File name format: <language>_<country>.json

// German
import de_AT from './de_AT.json'; // Austria
import de_DE from './de_DE.json'; // Germany

// French
import fr_BE from './fr_BE.json'; // Belgium
import fr_FR from './fr_FR.json'; // France
import fr_LU from './fr_LU.json'; // Luxembourg

// Italian
import it_IT from './it_IT.json';

// English
import en_IE from './en_IE.json'; // Ireland
import en_US from './en_US.json'; // United States
import en_MT from './en_MT.json'; // Malta

// Spanish
import es_ES from './es_ES.json'; // Spain

// Bulgarian
import bg_BG from './bg_BG.json'; // Bulgaria

// Czech
import cs_CZ from './cs_CZ.json'; // Czech Republic

// Denmark
import da_DK from './da_DK.json'; // Denmark

// Greek
import el_GR from './el_GR.json'; // Greece

// Estonian
import et_EE from './et_EE.json'; // Estonia

// Finnish
import fi_FI from './fi_FI.json'; // Finland

// Croatian
import hr_HR from './hr_HR.json'; // Croatia

// Hungarian
import hu_HU from './hu_HU.json'; // Hungary

// Lithuanian
import lt_LT from './lt_LT.json'; // Lithuania

// Latvian
import lv_LV from './lv_LV.json'; // Latvia

//Dutch
import nl_BE from './nl_BE.json'; // Belgium
import nl_NL from './nl_NL.json'; // Netherlands

// Poland
import pl_PL from './pl_PL.json'; // Poland

// Portuguese
import pt_PT from './pt_PT.json'; // Portugal

// Romanian
import ro_RO from './ro_RO.json'; // Romania

// Slovak
import sk_SK from './sk_SK.json'; // Slovakia

// Slovenian
import sl_SI from './sl_SI.json'; // Slovenia

// Swedish
import sv_SE from './sv_SE.json'; // Sweden

// Greek (Cyprus)
import el_CY from './el_CY.json'; // Cyprus

// This is the list of all available locales that your MFE supports
// You reuse the same locale file for multiple locales if they share the same translations

export default {
  de_AT,
  de_DE,
  fr_BE,
  fr_FR,
  it_IT,
  en_IE,
  en_US,
  es_ES,
  bg_BG,
  cs_CZ,
  da_DK,
  el_GR,
  et_EE,
  fi_FI,
  fr_LU,
  hr_HR,
  hu_HU,
  lt_LT,
  lv_LV,
  nl_BE,
  nl_NL,
  pl_PL,
  pt_PT,
  ro_RO,
  sk_SK,
  sl_SI,
  sv_SE,
  el_CY,
  en_MT
};
